const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_auth/auth-action.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

// Search params come from the URL, so the raw input is inherently untrusted —
// the schema is the boundary that turns it into a typed value (no `as` casts).
// `.catch(undefined)` keeps a malformed param from throwing; the component
// already handles a missing mode/oobCode.
const authActionSearchSchema = z.object({
  mode: z.string().optional().catch(undefined),
  oobCode: z.string().optional().catch(undefined),
  verifyCode: z.string().optional().catch(undefined),
  apiKey: z.string().optional().catch(undefined),
  continueUrl: z.string().optional().catch(undefined)
});
export const Route = createFileRoute('/_auth/auth-action')({
  validateSearch: authActionSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});